/* eslint-disable max-lines */
import attractionSrc from './icons/place/location-attraction.svg';
import beachSrc from './icons/place/location-beach.svg';
import bicycleSrc from './icons/place/location-bicycle.svg';
import bridgeSrc from './icons/place/location-bridge.svg';
import buildingSrc from './icons/place/location-building.svg';
import busSrc from './icons/place/location-bus.svg';
import campsiteSrc from './icons/place/location-campsite.svg';
import caveSrc from './icons/place/location-cave.svg';
import citySrc from './icons/place/location-city.svg';
import cliffSrc from './icons/place/location-cliff.svg';
import climbingSrc from './icons/place/location-climbing.svg';
import coordinateSrc from './icons/place/location-coordinate.svg';
import damSrc from './icons/place/location-dam.svg';
import discGolfSrc from './icons/place/location-disc-golf.svg';
import dogParkSrc from './icons/place/location-dog-park.svg';
import drinkingWaterSrc from './icons/place/location-drinking-water.svg';
import electricSrc from './icons/place/location-electric.svg';
import fellSrc from './icons/place/location-fell.svg';
import fishSrc from './icons/place/location-fish.svg';
import forestSrc from './icons/place/location-forest.svg';
import fuelSrc from './icons/place/location-fuel.svg';
import gardenSrc from './icons/place/location-garden.svg';
import gateSrc from './icons/place/location-gate.svg';
import glacierSrc from './icons/place/location-glacier.svg';
import grassSrc from './icons/place/location-grass.svg';
import grasslandSrc from './icons/place/location-grassland.svg';
import groundBlindSrc from './icons/place/location-ground-blind.svg';
import harborSrc from './icons/place/location-harbor.svg';
import heathSrc from './icons/place/location-heath.svg';
import hikingSrc from './icons/place/location-hiking.svg';
import horseSrc from './icons/place/location-horse.svg';
import hospitalSrc from './icons/place/location-hospital.svg';
import hotSpringSrc from './icons/place/location-hotspring.svg';
import lodgingSrc from './icons/place/location-lodging.svg';
import marketSrc from './icons/place/location-market.svg';
import marshSrc from './icons/place/location-marsh.svg';
import mineSrc from './icons/place/location-mine.svg';
import mudSrc from './icons/place/location-mud.svg';
import museumSrc from './icons/place/location-museum.svg';
import noAccessSrc from './icons/place/location-no-access.svg';
import parkSrc from './icons/place/location-park.svg';
import parkingSrc from './icons/place/location-parking.svg';
import peakSrc from './icons/place/location-peak.svg';
import picnicSrc from './icons/place/location-picnic.svg';
import rangerStationSrc from './icons/place/location-ranger-station.svg';
import reefSrc from './icons/place/location-reef.svg';
import restaurantSrc from './icons/place/location-restaurant.svg';
import rvSrc from './icons/place/location-rv-park.svg';
import saddleSrc from './icons/place/location-saddle.svg';
import sandSrc from './icons/place/location-sand.svg';
import scrubSrc from './icons/place/location-scrub.svg';
import shelterSrc from './icons/place/location-shelter.svg';
import skiSrc from './icons/place/location-ski.svg';
import snowmobileSrc from './icons/place/location-snowmobile.svg';
import springSrc from './icons/place/location-spring.svg';
import stepsSrc from './icons/place/location-steps.svg';
import stoneSrc from './icons/place/location-stone.svg';
import swimmingSrc from './icons/place/location-swimming.svg';
import toiletsSrc from './icons/place/location-toilets.svg';
import trailheadSrc from './icons/place/location-trailhead.svg';
import viewpointSrc from './icons/place/location-viewpoint.svg';
import volcanoSrc from './icons/place/location-volcano.svg';
import waterSrc from './icons/place/location-water.svg';
import waterfallSrc from './icons/place/location-waterfall.svg';
import woodSrc from './icons/place/location-wood.svg';

/*
 * Match OSM type names to an icon.
 * There should be an icon for for every type in `osm-import/mapping.yml`.
 *
 * "defaultPlaceIcon" will be used as a last resort fallback if an unknown
 * type is encountered but icons for all types ought to be specified.
 */

export type OSMPlaceName =
    | 'alpine_hut'
    | 'aquarium'
    | 'arete'
    | 'attraction'
    | 'bare_rock'
    | 'bay'
    | 'beach'
    | 'bicycle'
    | 'bridge'
    | 'bridleway'
    | 'bus_station'
    | 'camp_site'
    | 'cape'
    | 'caravan_site'
    | 'cave_entrance'
    | 'chalet'
    | 'charging_station'
    | 'city'
    | 'cliff'
    | 'climbing'
    | 'common'
    | 'coordinate'
    | 'cycleway'
    | 'dam'
    | 'disc_golf_course'
    | 'dog_park'
    | 'drinking_water'
    | 'drystream'
    | 'fell'
    | 'fishing'
    | 'foot'
    | 'footway'
    | 'forest'
    | 'fuel'
    | 'garden'
    | 'gate'
    | 'geyser'
    | 'glacier'
    | 'grass'
    | 'grassland'
    | 'grocery'
    | 'group_camp'
    | 'heath'
    | 'hiking'
    | 'hiking_trail'
    | 'horse'
    | 'horse_riding'
    | 'hot_spring'
    | 'known_route'
    | 'locality'
    | 'lodging'
    | 'marina'
    | 'marsh'
    | 'medical'
    | 'mountain_pass'
    | 'mtb'
    | 'mud'
    | 'museum'
    | 'national_park'
    | 'nature_reserve'
    | 'no_access'
    | 'nordic'
    | 'park'
    | 'parking'
    | 'path'
    | 'peak'
    | 'pedestrian'
    | 'picnic_site'
    | 'protected_area'
    | 'quarry_mine'
    | 'ranger_station'
    | 'reef'
    | 'restaurant'
    | 'ridge'
    | 'river'
    | 'rock'
    | 'saddle'
    | 'sand'
    | 'scree'
    | 'scrub'
    | 'shelter'
    | 'shopping'
    | 'sinkhole'
    | 'ski'
    | 'ski_area'
    | 'snowmobile'
    | 'sports_centre'
    | 'spring'
    | 'steps'
    | 'stepssteps' // handle bad data in source
    | 'stone'
    | 'stream'
    | 'summer_camp'
    | 'swimming_area'
    | 'theme_park'
    | 'toilets'
    | 'track'
    | 'tracktrack' // handle bad data in source
    | 'trail'
    | 'trailhead'
    | 'trailhead_xcski'
    | 'valley'
    | 'venue'
    | 'viewpoint'
    | 'volcano'
    | 'water'
    | 'waterfall'
    | 'wetland'
    | 'wilderness_hut'
    | 'wildlife_hide'
    | 'wood'
    | 'zoo';

export default {
    alpine_hut: <img src={buildingSrc} alt='alpine hut' />,
    aquarium: <img src={attractionSrc} alt='aquarium' />,
    arete: <img src={stoneSrc} alt='arete' />,
    attraction: <img src={attractionSrc} alt='attraction' />,
    bare_rock: <img src={stoneSrc} alt='bare rock' />,
    bay: <img src={waterSrc} alt='bay' />,
    beach: <img src={beachSrc} alt='beach' />,
    bicycle: <img src={bicycleSrc} alt='bicycle' />,
    bridge: <img src={bridgeSrc} alt='bridge' />,
    bridleway: <img src={horseSrc} alt='bridleway' />,
    bus_station: <img src={busSrc} alt='bus station' />,
    camp_site: <img src={campsiteSrc} alt='camp site' />,
    cape: <img src={stoneSrc} alt='cape' />,
    caravan_site: <img src={rvSrc} alt='caravan site' />,
    cave_entrance: <img src={caveSrc} alt='cave entrance' />,
    chalet: <img src={attractionSrc} alt='chalet' />,
    charging_station: <img src={electricSrc} alt='charging station' />,
    city: <img src={citySrc} alt='city' />,
    cliff: <img src={cliffSrc} alt='cliff' />,
    climbing: <img src={climbingSrc} alt='climbing' />,
    common: <img src={grasslandSrc} alt='common' />,
    coordinate: <img src={coordinateSrc} alt='coordinate' />,
    cycleway: <img src={bicycleSrc} alt='cycleway' />,
    dam: <img src={damSrc} alt='dam' />,
    disc_golf_course: <img src={discGolfSrc} alt='disc golf course' />,
    dog_park: <img src={dogParkSrc} alt='dog park' />,
    drinking_water: <img src={drinkingWaterSrc} alt='drinking water' />,
    drystream: <img src={waterSrc} alt='dry stream' />,
    fell: <img src={fellSrc} alt='fell' />,
    fishing: <img src={fishSrc} alt='fishing' />,
    foot: <img src={trailheadSrc} alt='foot' />,
    footway: <img src={trailheadSrc} alt='footway' />,
    forest: <img src={forestSrc} alt='forest' />,
    fuel: <img src={fuelSrc} alt='fuel' />,
    garden: <img src={gardenSrc} alt='garden' />,
    gate: <img src={gateSrc} alt='gate' />,
    geyser: <img src={springSrc} alt='geyser' />,
    glacier: <img src={glacierSrc} alt='glacier' />,
    grass: <img src={grassSrc} alt='grass' />,
    grassland: <img src={grasslandSrc} alt='grassland' />,
    grocery: <img src={marketSrc} alt='grocery' />,
    group_camp: <img src={campsiteSrc} alt='camp site' />,
    heath: <img src={heathSrc} alt='heath' />,
    hiking: <img src={hikingSrc} alt='hiking' />,
    hiking_trail: <img src={hikingSrc} alt='hiking trail' />,
    horse: <img src={horseSrc} alt='horse' />,
    horse_riding: <img src={horseSrc} alt='horse riding' />,
    hot_spring: <img src={hotSpringSrc} alt='hot spring' />,
    known_route: <img src={hikingSrc} alt='hiking route' />,
    locality: <img src={citySrc} alt='locality' />,
    lodging: <img src={lodgingSrc} alt='lodging' />,
    marina: <img src={harborSrc} alt='marina' />,
    marsh: <img src={marshSrc} alt='marsh' />,
    medical: <img src={hospitalSrc} alt='medical' />,
    mountain_pass: <img src={saddleSrc} alt='mountain pass' />,
    mtb: <img src={bicycleSrc} alt='mountain bike trail' />,
    mud: <img src={mudSrc} alt='mud' />,
    museum: <img src={museumSrc} alt='museum' />,
    national_park: <img src={parkSrc} alt='national park' />,
    nature_reserve: <img src={parkSrc} alt='nature reserve' />,
    no_access: <img src={noAccessSrc} alt='no access' />,
    nordic: <img src={skiSrc} alt='nordic' />,
    park: <img src={parkSrc} alt='park' />,
    parking: <img src={parkingSrc} alt='parking' />,
    path: <img src={trailheadSrc} alt='path' />,
    peak: <img src={peakSrc} alt='peak' />,
    pedestrian: <img src={trailheadSrc} alt='pedestrian' />,
    picnic_site: <img src={picnicSrc} alt='picnic site' />,
    protected_area: <img src={parkSrc} alt='protected area' />,
    quarry_mine: <img src={mineSrc} alt='quarry' />,
    ranger_station: <img src={rangerStationSrc} alt='ranger station' />,
    reef: <img src={reefSrc} alt='reef' />,
    restaurant: <img src={restaurantSrc} alt='restaurant' />,
    ridge: <img src={stoneSrc} alt='ridge' />,
    river: <img src={waterSrc} alt='river' />,
    rock: <img src={stoneSrc} alt='rock' />,
    saddle: <img src={saddleSrc} alt='saddle' />,
    sand: <img src={sandSrc} alt='sand' />,
    scree: <img src={stoneSrc} alt='scree' />,
    scrub: <img src={scrubSrc} alt='scrub' />,
    shelter: <img src={shelterSrc} alt='shelter' />,
    shopping: <img src={marketSrc} alt='shopping' />,
    sinkhole: <img src={stoneSrc} alt='sinkhole' />,
    ski: <img src={skiSrc} alt='ski' />,
    ski_area: <img src={skiSrc} alt='ski area' />,
    snowmobile: <img src={snowmobileSrc} alt='snowmobile' />,
    sports_centre: <img src={attractionSrc} alt='sports center' />,
    spring: <img src={springSrc} alt='spring' />,
    steps: <img src={stepsSrc} alt='steps' />,
    stepssteps: <img src={stepsSrc} alt='steps' />, // handle bad data in source
    stone: <img src={stoneSrc} alt='stone' />,
    stream: <img src={waterSrc} alt='stream' />,
    summer_camp: <img src={campsiteSrc} alt='campsite' />,
    swimming_area: <img src={swimmingSrc} alt='swimming area' />,
    theme_park: <img src={attractionSrc} alt='theme park' />,
    toilets: <img src={toiletsSrc} alt='toilets' />,
    track: <img src={trailheadSrc} alt='track' />, // handle bad data in source
    tracktrack: <img src={trailheadSrc} alt='track' />,
    trail: <img src={trailheadSrc} alt='trail' />,
    trailhead: <img src={trailheadSrc} alt='trailhead' />,
    trailhead_xcski: <img src={trailheadSrc} alt='cross country skiing' />,
    valley: <img src={coordinateSrc} alt='valley' />,
    venue: <img src={attractionSrc} alt='venue' />,
    viewpoint: <img src={viewpointSrc} alt='viewpoint' />,
    volcano: <img src={volcanoSrc} alt='volcano' />,
    water: <img src={waterSrc} alt='water' />,
    waterfall: <img src={waterfallSrc} alt='waterfall' />,
    wetland: <img src={marshSrc} alt='wetland' />,
    wilderness_hut: <img src={buildingSrc} alt='wilderness hut' />,
    wildlife_hide: <img src={groundBlindSrc} alt='wildlife hide' />,
    wood: <img src={woodSrc} alt='wood' />,
    zoo: <img src={attractionSrc} alt='zoo' />,
};

export const mapPlaceIconToGaiaWaypointIcon: Record<OSMPlaceName, UnifiedMarkerName> = {
    alpine_hut: 'building',
    aquarium: 'attraction',
    arete: 'stone',
    attraction: 'attraction',
    bare_rock: 'stone',
    bay: 'water',
    beach: 'beach',
    bicycle: 'bicycle',
    bridleway: 'horse',
    bridge: 'bridge',
    bus_station: 'bus',
    camp_site: 'campsite',
    cape: 'stone',
    caravan_site: 'rv-park',
    cave_entrance: 'cave',
    chalet: 'attraction',
    charging_station: 'electric',
    city: 'city',
    cliff: 'cliff',
    climbing: 'climbing',
    common: 'grass',
    coordinate: 'pin',
    cycleway: 'bicycle',
    dam: 'dam',
    disc_golf_course: 'disc-golf',
    dog_park: 'dog-park',
    drinking_water: 'potable-water',
    drystream: 'water',
    fell: 'pin',
    fishing: 'fish',
    foot: 'trailhead',
    footway: 'trailhead',
    forest: 'forest',
    fuel: 'fuel',
    garden: 'garden',
    gate: 'gate',
    geyser: 'geyser',
    glacier: 'snowflake',
    grass: 'grass',
    grassland: 'grass',
    grocery: 'market',
    group_camp: 'campsite',
    heath: 'pin',
    hiking: 'known-route',
    hiking_trail: 'known-route',
    horse: 'horse',
    horse_riding: 'horse',
    hot_spring: 'hotspring',
    known_route: 'known-route',
    locality: 'city',
    lodging: 'lodging',
    marina: 'harbor',
    marsh: 'marsh',
    medical: 'hospital',
    mountain_pass: 'saddle',
    mtb: 'bicycle',
    mud: 'mud',
    museum: 'museum',
    national_park: 'park',
    nature_reserve: 'park',
    no_access: 'no-admittance-1',
    nordic: 'skiing',
    park: 'park',
    parking: 'parking',
    path: 'trailhead',
    peak: 'peak',
    pedestrian: 'trailhead',
    picnic_site: 'picnic',
    protected_area: 'park',
    quarry_mine: 'mine',
    ranger_station: 'ranger-station',
    reef: 'reef',
    restaurant: 'restaurant',
    ridge: 'stone',
    river: 'water',
    rock: 'stone',
    saddle: 'saddle',
    sand: 'sand-dune',
    scree: 'stone',
    scrub: 'scrub',
    shelter: 'shelter',
    shopping: 'market',
    sinkhole: 'stone',
    ski: 'skiing',
    ski_area: 'skiing',
    snowmobile: 'snowmobile',
    sports_centre: 'attraction',
    spring: 'natural-spring',
    steps: 'steps',
    stepssteps: 'steps', // handle bad data in source
    stone: 'stone',
    stream: 'water',
    summer_camp: 'campsite',
    swimming_area: 'swimming',
    theme_park: 'attraction',
    toilets: 'toilets',
    track: 'trailhead', // handle bad data in source
    tracktrack: 'trailhead',
    trail: 'trailhead',
    trailhead: 'trailhead',
    trailhead_xcski: 'trailhead',
    valley: 'pin',
    venue: 'attraction',
    viewpoint: 'binoculars',
    volcano: 'volcano',
    water: 'water',
    waterfall: 'waterfall',
    wetland: 'marsh',
    wilderness_hut: 'building',
    wildlife_hide: 'ground-blind',
    wood: 'wood',
    zoo: 'attraction',
};

export const defaultPlaceIcon = <img src={coordinateSrc} alt='coordinate' />;
